module.exports = __webpack_public_path__ + "img/ouro.99fba9c7.png";